<template>
  <a
    class="d-tracking-link"
    @click="trackEvent"
  >
    <slot />
  </a>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    eventName: {
      type: String,
      required: true,
    },
    forceNewTrackingChain: {
      type: Boolean,
      default: false,
    },
    trackingExtra: {
      type: Object,
      default: null,
    },
    trackingModals: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    trackEvent() {
      if (!!this.trackingModals) {
        Vue.prototype.trackingHandler.trackEvent(
          this.trackingModals.modalId,
          this.trackingModals.eventName,
        );
      }

      Vue.prototype.eventsTracking.trackAndRedirect(
        this.eventName,
        this.trackingExtra,
        this.url,
        this.forceNewTrackingChain,
      );
    },
  },
};
</script>
